// React app
// const { render } = wp.element;
// import TooltipModal from "../parts/TooltipModal";

// const textContentsDefault = {
//     tagline: "Package Protection",
//     headline: "Lost package protection",
//     subhead: "Lost packages shouldn't equal lost revenue",
//     copy: "Still paying for lost packages? Let Route cover that cost. With package protection at checkout, customers can protect any order so shipping issues don’t impact your bottom line.",
//     img: pricingArgs.stylesheet_directory_uri + "/assets/imgs/package-protection-app-demo.webp",
//     excluded: [
//         "basic"
//     ]
// };

// const PricingTooltipModal = () => {
//     return (
//         <div>
//             <TooltipModal textContents={textContentsDefault} triggerIDs={pricingArgs.triggerIDs} textContentArr={pricingArgs.textContentArr}/>
//         </div>
//     )
// }

// render(<PricingTooltipModal />, document.getElementById(`tooltip-modal-app`));

// Vanilla JS
document.addEventListener("DOMContentLoaded", () => {
    let el = document.querySelector('#mn-section-4-sticky-header');
    let elMid = document.querySelector('#mn-section-4-sticky-header-mid');
    let elMidScrollPos = elMid.offsetTop;
    let isPositionFixed = (el.style.position == 'fixed');
    let elScrollPos = el.offsetTop;

    let compareEl = document.querySelector('#mn-section-3-compare-plans-button' );
    let compareElStop = document.querySelector('#mn-section-4-down-arrow' );
    let compareElStart = document.querySelector('#mn-section-1-compare-toggle' ).offsetTop;
    let compareIsFixed = false;

    let pricingCardsContainer = document.querySelector('#mn-pricing-plan-card-contents' );
    let containerTopPadding = 55;
    let effectSpeed = 3;

    // let pricingCardsOverlay = $( '#mn-pricing-plan-overlay' );
    // let overlayenabled = true;


    if( elScrollPos == 0 ){
        elScrollPos = elMidScrollPos;
        el = elMid;
    }

    // $(window).load(function(){
    //     if ( $(window).scrollTop() > 0 ){
    //         pricingCardsOverlay.css("display", "none");
    //         overlayenabled = false;
    //     }
    // });

    window.addEventListener("scroll", () => {
        let compareElStopVal = compareElStop.getBoundingClientRect().top - window.innerHeight;
        let windowScrollTop = window.scrollY;

        // Sticky header above comparison table (does not work going between mobile and desktop view)
        if ((windowScrollTop - elScrollPos) <= 200 && (windowScrollTop - elScrollPos) >= -48 && !isPositionFixed){ 
            el.style.position = 'fixed';
            el.style.top = '4.8rem';
            isPositionFixed = true;
        }
        if ((windowScrollTop - elScrollPos) <= -48 && isPositionFixed){
            el.style.position = 'relative';
            el.style.top = '0';
            isPositionFixed = false;
        }

        // Compare plans sticky on mobile
        if ( window.innerWidth <= 743 ) {
            if( windowScrollTop <= ( containerTopPadding * effectSpeed ) && windowScrollTop > 0 ) {
                pricingCardsContainer.style["padding-top"] = `${ (containerTopPadding - ( windowScrollTop / effectSpeed))/10 }rem`;
                pricingCardsContainer.style.setProperty("background-position-y", ( ( ( containerTopPadding - ( windowScrollTop / effectSpeed) ) * 0.7272) /10 ) + "rem", "important" );
            }
            if( compareElStopVal <= 0 && compareIsFixed ){
                compareEl.style.position = 'relative';
                compareEl.style.bottom = '0';
                compareIsFixed = false;
            }
            if ( windowScrollTop < compareElStart  && compareIsFixed ) {
                compareEl.style.position = 'relative';
                compareEl.style.bottom = '2rem';
                compareEl.style.width = '100%';
                compareEl.style["max-width"] = '19.1rem';
                compareIsFixed = false;
            }
            if( compareElStopVal >= 0 && !compareIsFixed  && windowScrollTop > compareElStart ){
                compareEl.style.position = 'fixed';
                compareEl.style.bottom = '2rem';
                compareEl.style.width = '100%';
                compareEl.style["max-width"] = '19.1rem';
                compareIsFixed = true;
            }
        } else {
            if ( compareIsFixed ) {
                compareEl.style.position = 'relative';
                compareEl.style.bottom = '2rem';
                compareIsFixed = false;
            }
        }
    });

    document.querySelectorAll(".mn-section-5-row:not(.mn-section-5-header-row):not(.mn-section-5-spacer) .mn-section-5-column-1-box").forEach( (boxEl) => {
        boxEl.querySelector("h5").addEventListener("click", () => {
            if( boxEl.parentElement.getAttribute("enable-hover") == null ){
                return;
            } 
            
            // let descTextEl = boxEl.parentElement.querySelector( ".mn-section5-column-1-desc" );
            
            // if( descTextEl.getAttribute("shown") ) {
            //     descTextEl.removeAttribute("shown");
            //     descTextEl.style.display = "none";
            // } else {
            //     descTextEl.style.display = "block";
            //     descTextEl.setAttribute("shown", "true");
            // }
        });
    });
});